import React from 'react';
import Toaster from '../../stories/Toasts/Toaster';
import PropTypes from 'prop-types';

const ErrorToaster = ({ error, onClose }) => {
  if (!error) return null;

  return (
    <Toaster
      body={error}
      header="Error"
      onClose={onClose}
      position="top-end"
      show={!!error}
    />
  );
};

ErrorToaster.propTypes = {
  error: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default ErrorToaster;